/**
 * Event for configuration iframe integration
 *
 * @category ConfigurationEvent
 */
export var ConfigurationParentEventId;
(function (ConfigurationParentEventId) {
    /**
     * Should reload the current configuration from server
     */
    ConfigurationParentEventId["ConfigurationReload"] = "configuration-reload";
})(ConfigurationParentEventId || (ConfigurationParentEventId = {}));
/**
 * Configuration changed by parent of iframe
 * - should trigger a reload of the configuration
 *
 * @category ConfigurationEvent
 */
export class ConfigurationReloadEvent {
    constructor(sessionId) {
        this.cfgEvent = ConfigurationParentEventId.ConfigurationReload;
        this.sessionId = sessionId;
    }
}
//# sourceMappingURL=ConfigurationParentEvent.js.map